import React from 'react';

import moment from 'moment-timezone';
import styled from 'styled-components';

const StyledModifiedDate = styled.div`
  color: #767676;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 4px;
`;

const StyledModifiedByUser = styled.div`
  color: #767676;
  font-size: 16px;
  font-weight: 400;
`;
const ModifiedCell = ({ dataTest, item }) => {
  let modifiedBy = '';
  let createdOn = '';

  if (item.latestActivityAudit) {
    const { latestActivityAudit } = item;
    const { user } = latestActivityAudit;

    modifiedBy = `${user.firstName} ${user.lastName}`;
    createdOn = latestActivityAudit.createdOn;
  } else {
    createdOn = item.createdOn;
  }

  const created = moment(createdOn).valueOf();
  const current = new Date().getTime();

  const createdOnHours = moment.duration(created).asHours();
  const currentHours = moment.duration(current).asHours();
  const hourDiff = currentHours - createdOnHours;

  const displayTime =
    hourDiff < 35
      ? moment(created).fromNow()
      : moment(created).format('MMM D, YYYY');

  return (
    <div data-testid={dataTest}>
      <StyledModifiedByUser className="dd-privacy-mask">
        {modifiedBy}
      </StyledModifiedByUser>
      <StyledModifiedDate>{displayTime}</StyledModifiedDate>
    </div>
  );
};

export default ModifiedCell;
